export default "__VITE_ASSET__DvSf8Rjr__"